import { render, staticRenderFns } from "./AccountSidebarAddRefund.vue?vue&type=template&id=a2bdf590&"
import script from "./AccountSidebarAddRefund.vue?vue&type=script&lang=js&"
export * from "./AccountSidebarAddRefund.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports